import logo from './logo.svg';
import './App.css';
import { Router } from './router/Router';

function App() {
  return (
    <div className="App fondo-blanco">
      <Router />
    </div>
  );
}

export default App;
